import { useSelector } from 'react-redux';
import { formatCurrency } from '@shared/commonFunctions';
import { useAppDispatch } from '@store/hooks';
import { Column, 
        Divider, 
        Label, 
        Notes, 
        NotesSection, 
        Row, 
        Table, 
        DealCalculatorWrapper, 
        ButtonsSection} 
from '@styles/ContactManager/DealCalculator/DealCalculatorStyles';
import { SaveButton } from '@shared/components/SaveButton';
import { footerLenderSelector, setFooterLenderAction } from '../../../../../../../store/reducers/dealCalculatorSlice';
import { ILenderFooterState } from '../interfaces';
import { IGlobalInputs } from '../models/GlobalInputsModel';



interface IDealCalculatorFooterProps {
  handleSubmitCalculator: (withClosingModal?: boolean) => void;
  loading: boolean;
  globalInputs?: IGlobalInputs;
}

export const DealCalculatorFooter = ({ handleSubmitCalculator, loading, globalInputs }: IDealCalculatorFooterProps) => {
  const footerLender: Partial<ILenderFooterState> | null = useSelector(footerLenderSelector);

  const dispatch = useAppDispatch();
  const onChangeNotes = (value: string) => {
    dispatch(
      setFooterLenderAction({
        additionalNotes: value,
      }),
    );
  };

  return (
    <>
      <DealCalculatorWrapper>
        <Divider regular inverse />

        <Table>
          <Column>
            <Row white />
            <Row>
              <b>Current</b>
            </Row>
            <Row>
              <b>New</b>
            </Row>
          </Column>

          <Column>
            <Row white>
              <b>Rate</b>
            </Row>
            <Row>{globalInputs?.lienRate || 0}</Row>
            <Row>{footerLender?.rate}%</Row>
          </Column>

          <Column>
            <Row white>
              <b>Pmt</b>
            </Row>
            <Row>{formatCurrency(globalInputs?.lienPayment || 0)}</Row>
            <Row>{formatCurrency(footerLender?.payment)}</Row>
          </Column>

          <Column>
            <Row white>
              <b>Term</b>
            </Row>
            <Row>{globalInputs?.term || 0}</Row>
            <Row>{footerLender?.term}</Row>
          </Column>

          <Column>
            <Row white>
              <b>Remaining Term</b>
            </Row>
            <Row>{globalInputs?.remainingTerm || 0}</Row>
            <Row>{footerLender?.remainingTerm}</Row>
          </Column>
          <Column>
            <Row white>
              <b>DTI</b>
            </Row>
            <Row>{footerLender?.currentDTI || 0}</Row>
            <Row>{footerLender?.newDTI || 0}</Row>
          </Column>
          <Column>
            <Row white>
              <b>GAP</b>
            </Row>
            <Row>{globalInputs?.gapRefund && globalInputs.gapRefund > 0 ? 'Y' : 'N'}</Row>
            <Row>{footerLender?.GAP && footerLender?.GAP >= 0 ? 'Y' : 'N'}</Row>
          </Column>

          <Column>
            <Row white>
              <b>VSC</b>
            </Row>
            <Row>{globalInputs?.vscRefund && globalInputs.vscRefund > 0 ? 'Y' : 'N'}</Row>
            <Row>{footerLender?.VSC && footerLender?.VSC >= 0 ? 'Y' : 'N'}</Row>
          </Column>

          <Column>
            <Row white>
              <b>P&F</b>
            </Row>
            <Row>N/A</Row>
            <Row>{footerLender?.PAF && footerLender?.PAF >= 0 ? 'Y' : 'N'}</Row>
          </Column>

          <Column>
            <Row white>
              <b>Down Pmt</b>
            </Row>
            <Row>N/A</Row>
            <Row>{footerLender?.downPayment && footerLender?.downPayment >= 0 ? 'Y' : 'N'}</Row>
          </Column>

          <Column>
            <Row white>
              <b>1st Pmt</b>
            </Row>
            <Row>N/A</Row>
            <Row>{formatCurrency(footerLender?.downPayment)}</Row>
          </Column>
        </Table>

        <NotesSection>
          <Label>Additional Notes</Label>
          <Notes value={footerLender?.additionalNotes ?? ''} onChange={(e) => onChangeNotes(e.target.value)} />
        </NotesSection>

        <ButtonsSection>
          <SaveButton top='110px' width='123px' variant="contained" label='Save' type='button' disabled={loading} position='initial' onClick={() => handleSubmitCalculator()}/>
          <SaveButton top='120px' width='123px' variant="contained" label='Save and Close' type='button' disabled={loading} position='initial' onClick={() => handleSubmitCalculator(true)}/>
          
        </ButtonsSection>
        
      </DealCalculatorWrapper>
    </>
  );
};
